var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @desc color legend
 */
import { ComponentModel } from '../../model';
import { Group, createText, createRef } from '../../element';
import { createSymbolAtCenter } from '../../symbol';
import { registerComponent } from '../index';
import { getBoxLabelPosition } from '../../utils/textLayout';
import { getSymbolSize } from '../../utils/styleHelper';
import template from '../../utils/template';
import { inRange } from '../../utils/math';
var DATA_MARKER = 'dataMarker';
var DataMarker = /** @class */ (function (_super) {
    __extends(DataMarker, _super);
    function DataMarker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = DATA_MARKER;
        _this.renderAfterSeires = true;
        _this.zindex = 999;
        return _this;
    }
    DataMarker.prototype.getDefaultOption = function () {
        return {
            points: [],
            symbol: 'tooltip',
            symbolSize: [40, 22],
            offsetX: 0,
            offsetY: 0,
            seriesIndex: 0,
            label: {
                show: true,
                position: 'inside',
                formatter: function (point) { return point.text; },
                distance: 5,
                color: '#ffffff',
                fontSize: 12,
                textAlign: 'center',
                textBaseline: 'middle',
                offsetX: 0,
                offsetY: 0,
            },
            shapeStyle: {
                fill: null,
                stroke: null,
                lineWidth: 0,
            },
        };
    };
    DataMarker.prototype.getInitialState = function () {
        return {
            points: [],
        };
    };
    DataMarker.prototype.beforeRender = function () {
        var _this = this;
        var coord = this.chart.getComponentModel('coord');
        var points = [];
        var seriesIndex = this.option.seriesIndex;
        var seriesModel = this.chart.getSeriesModel(seriesIndex);
        if (!seriesModel) {
            return this.setState({ points: [] });
        }
        var _a = seriesModel.getOption(), xAxis = _a.xAxis, yAxis = _a.yAxis;
        this.option.points.forEach(function (point) {
            var type = point.type;
            var x = point.x, y = point.y;
            var xAxisModel = coord.getAxis('x', xAxis);
            var yAxisModel = coord.getAxis('y', yAxis);
            var plotX;
            var plotY;
            var text = point.text;
            if (seriesModel.getDataset().count() === 0 || !seriesModel.visible()) {
                return;
            }
            if (type === 'max' || type === 'min') {
                var extremPoint = _this._findExtremePoint(seriesModel.getState().points, type);
                plotX = extremPoint.plotX;
                plotY = extremPoint.plotY;
                text = String(extremPoint.value);
                var seriesCoord = seriesModel.getCoord();
                var categoryAxis = seriesCoord.getCategoryAxis();
                if (categoryAxis.shortType === 'x') {
                    x = seriesModel.getState().points.indexOf(extremPoint);
                    y = extremPoint.value;
                }
            }
            else {
                plotX = xAxisModel.scale.scale(x);
                plotY = yAxisModel.scale.scale(y);
            }
            var xRange = xAxisModel.scale.getPositionRange();
            var yRange = yAxisModel.scale.getPositionRange();
            var visible = inRange(plotX, xRange) && inRange(plotY, yRange);
            points.push({
                shapeRef: createRef(),
                plotX: plotX,
                plotY: plotY,
                text: text,
                color: seriesModel.getSeriesColor(),
                visible: visible,
                point: __assign(__assign({}, point), { x: x, y: y }),
            });
        });
        this.setState({ points: points });
    };
    DataMarker.prototype._findExtremePoint = function (points, type) {
        var extremeValue = Number(points[0].value);
        var extremePoint = points[0];
        for (var i = 1; i < points.length; i++) {
            var value = Number(points[i].value);
            if ((type === 'max' && value > extremeValue) || (type === 'min' && value < extremeValue)) {
                extremePoint = points[i];
                extremeValue = points[i].value;
            }
        }
        return extremePoint;
    };
    DataMarker.prototype.render = function () {
        var _this = this;
        var group = new Group({
            key: this.getKey(this.type),
            cursor: 'pointer',
        });
        var _a = this.option, symbol = _a.symbol, offsetX = _a.offsetX, offsetY = _a.offsetY;
        var _b = this.option.label, position = _b.position, distance = _b.distance, formatter = _b.formatter, labelOffsetX = _b.offsetX, labelOffsetY = _b.offsetY;
        var _c = getSymbolSize(this.option.symbolSize), width = _c[0], height = _c[1];
        var textStyle = this.getTextStyle(this.option.label);
        var shapeStyel = this.getShapeStyle(this.option.shapeStyle);
        this.state.points.forEach(function (point, index) {
            if (!point.visible) {
                return;
            }
            var _a = point.point, _b = _a.offsetX, pointOffsetX = _b === void 0 ? offsetX : _b, _c = _a.offsetY, pointOffsetY = _c === void 0 ? offsetY : _c;
            var markerGroup = new Group({
                key: index,
                ref: point.shapeRef,
                onEvent: function (event) { return _this.handleUIEvent(event, 'dataMarker', point); },
                onMouseEnter: function (e) { return e.currentTarget.parentNode.add(e.currentTarget); },
            });
            var marker = createSymbolAtCenter(symbol, point.plotX + pointOffsetX, point.plotY + pointOffsetY, width, height, __assign({ fill: point.color }, shapeStyel));
            markerGroup.add(marker);
            var bbox = marker.getBoundingClientRect();
            var textPosition = getBoxLabelPosition(bbox, position, distance, 'top');
            // to make symbol in center position
            if (symbol === 'pin') {
                textPosition.y -= height / 10;
            }
            if (symbol === 'tooltip') {
                textPosition.y -= 1.5;
            }
            textPosition.x += labelOffsetX;
            textPosition.y += labelOffsetY;
            var label = typeof formatter === 'function' ? formatter(point) : template(formatter, point);
            markerGroup.add(createText(__assign(__assign({ text: label }, textPosition), textStyle)));
            group.add(markerGroup);
        });
        this.chart.addToTopLevel(group, 999);
        return null;
    };
    DataMarker.multiple = true;
    return DataMarker;
}(ComponentModel));
export default DataMarker;
registerComponent(DATA_MARKER, DataMarker);
